import { authHeaders, invokeApi, postRequest } from '../components/network/apiclient';
import { favouriteGamesEndpoint } from './endpoint';

export const fetchFavouriteGames = (token, onSuccess, onError, filter) =>
    invokeApi(postRequest(favouriteGamesEndpoint.findByFilter(), authHeaders(token), { filter }), onSuccess, onError);

export const addFavouriteGame = (token, onSuccess, onError, favouriteGameInfo) =>
    invokeApi(postRequest(favouriteGamesEndpoint.addPath(), authHeaders(token), { favouriteGameInfo }), onSuccess, onError);

export const deleteFavouriteGameById = (token, onSuccess, onError, gameId) =>
    invokeApi(postRequest(favouriteGamesEndpoint.deleteByIdPath(), authHeaders(token), { favouriteGameId: gameId }), onSuccess, onError);

export const deleteFavouriteGameByLink = (token, onSuccess, onError, game) =>
    invokeApi(postRequest(favouriteGamesEndpoint.deleteByLinkPath(), authHeaders(token), { link: game.link }), onSuccess, onError);
